import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popup-leader',
  templateUrl: './popup-leader.component.html',
  styleUrls: ['./popup-leader.component.scss']
})
export class PopupLeaderComponent implements OnInit {
  @Input() stats: any = {};

  constructor() { }

  ngOnInit() {
  }

}
